import { IAppState } from '../../../../core/redux/IAppState';
import { ACTION_TYPE } from '../../../../core/redux/actionType';
import ImmutableMap from '../../../../language/ImmutableMap';
import { Action } from 'redux';
import { assoc } from '../../../../language/module';


/**
 * Makes an action that can be dispatched to clear a guest's stay history.
 */
export const clearResortRedemptionsAction = () => ({ type: ACTION_TYPE.CLEAR_RESORTS_HISTORY });


/**
 * Function that maps actions into new app state. Specifically, clears app state with information from actions related
 * to a guest's redemptions at resorts. Returns a new app state, of course.
 */
export const clearResortRedemptionsReducer = (state: IAppState, action: Action): IAppState => {
  if (action.type !== ACTION_TYPE.CLEAR_RESORTS_HISTORY) {
    return state;
  }

  return assoc('guestResortHistories', ImmutableMap.empty(), state) as IAppState;
};
